import { useContext, useMemo } from "react";
import { ConditionalLink, ConditionalLinkProps } from "../ConditionalLink/ConditionalLink";
import { SessionContext } from "../../contexts/SessionContext";

interface PrintCompatibleLinkProps extends ConditionalLinkProps {
  isPrinting?: boolean;
}

export const PrintCompatibleLink = ({ to, children, isPrinting = false, ...props }: PrintCompatibleLinkProps) => {
  const { api } = useContext(SessionContext);
  const absoluteLink = useMemo(() => {
    const { hostname, protocol } = api.getUrlComponents();
    var baseLink = `${protocol}//${hostname}`;
    if (process.env.NODE_ENV === "development") return `${baseLink}${to}`;
    const port =
      window.location.port &&
      !(
        (protocol === "http:" && window.location.port === "80") ||
        (protocol === "https:" && window.location.port === "443")
      )
        ? `:${window.location.port}`
        : "";
    return `${baseLink}${port}${to}`;
  }, [api, to]);
  const { isPrintContext } = useContext(SessionContext);
  if (isPrinting || isPrintContext) {
    return (
      <a
        id="printCompatibleLink"
        className={props.className}
        style={props.style}
        href={absoluteLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }
  return (
    <ConditionalLink {...props} to={to}>
      {children}
    </ConditionalLink>
  );
};
